var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper layout_dashboard",class:{ 'nav-open': _vm.$sidebar.showSidebar }},[_c('sidebar-fixed-toggle-button'),_c('side-bar',{attrs:{"background-color":_vm.sidebarBackground,"short-title":"Mandaa","title":"Mandaa"}},[_c('template',{slot:"links"},[_c('sidebar-item',{attrs:{"link":{
          name: this.$t('dashboard:sidebar.dashboard'),
          icon: 'tim-icons icon-chart-pie-36',
          path: '/dashboard',
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: this.$t('dashboard:sidebar.invoices'),
          icon: 'tim-icons icon-notes',
          path: '/invoices/view',
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: this.$t('dashboard:sidebar.customers'),
          icon: 'tim-icons icon-single-02',
          path: '/receivers/view',
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: this.$t('dashboard:sidebar.contact'),
          icon: 'tim-icons icon-email-85',
          path: '/contact',
        }}})],1)],2),_c('div',{staticClass:"main-panel",attrs:{"data":_vm.sidebarBackground}},[_c('dashboard-navbar'),_c('div',{staticClass:"content"},[_c('FadeTransition',{attrs:{"duration":200,"mode":"out-in"}},[_c('router-view')],1)],1),_c('dashboard-footer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }